import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { Button, Col, Form, Input, Layout, Row, Typography } from 'antd';
import { useState } from 'react';

import { isAuthenticated, LoginRequest, useLogin } from '@/api/useAuth';
import { MainFooter } from '@/components/layout/MainFooter';
import { ROUTE_CONSTANTS } from '@/routes';
import { getImageUrl, showMessage } from '@/shared/utils';

const { Content } = Layout;

export const Route = createFileRoute('/login')({
  component: LoginPage,
  beforeLoad: () => {
    if (isAuthenticated()) {
      throw redirect({
        to: ROUTE_CONSTANTS.APPS_PATH,
      });
    }
  },
});

function LoginPage() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const login = useLogin();

  const onFinish = async (values: LoginRequest) => {
    setLoading(true);

    await login.mutateAsync(values, {
      onSuccess: () => {
        setLoading(false);
        showMessage('success', 'Anmeldung erfolgreich');
      },
      onError: () => {
        setLoading(false);
        showMessage('error', 'Anmeldung fehlgeschlagen');
      },
    });
  };

  return (
    <Layout style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Content style={{ flex: 1 }}>
        <div style={{ width: '100%', background: '#fff', padding: '100px 20px 100px 200px' }}>
          <img
            src={getImageUrl('/images/mailalliance-logo.svg')}
            alt='mail alliance Logo'
            style={{ width: '400px', maxWidth: '100%', marginBottom: 0 }}
          />
        </div>
        <div style={{ background: '#ccc', width: '100%', padding: '30px 20px 30px 200px' }}>
          <Row>
            <Col xs={22} sm={16} md={12} lg={8} xl={6}>
              <div style={{ marginBottom: 24 }}>
                <Typography.Title level={2} style={{ marginTop: 0, fontWeight: 700, fontSize: 50 }}>
                  Login<span style={{ color: 'red' }}>.</span>
                </Typography.Title>
                <div style={{ marginBottom: 12, fontSize: 12, color: '#333' }}>
                  Zugangsdaten erhalten nur Partner oder Lieferanten der mail alliance.
                </div>
              </div>
              <Form form={form} name='loginForm' onFinish={onFinish} layout='vertical'>
                <Form.Item
                  name='username'
                  rules={[{ required: true, message: 'Bitte geben Sie Ihren Benutzernamen ein' }]}
                >
                  <Input prefix={<UserOutlined />} placeholder='Username' size='large' />
                </Form.Item>
                <Form.Item
                  name='password'
                  rules={[{ required: true, message: 'Bitte geben Sie Ihr Passwort ein' }]}
                >
                  <Input.Password prefix={<LockOutlined />} placeholder='Passwort' size='large' />
                </Form.Item>
                <Form.Item style={{ marginBottom: 0 }}>
                  <Button type='primary' htmlType='submit' size='large' block loading={loading}>
                    Einloggen
                  </Button>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </div>
      </Content>
      <MainFooter />
    </Layout>
  );
}
